import PlayLabelPopover from '../PlayLabelPopover';
import PlayButtonPopover from '../PlayButtonPopover';
import ThumbnailPopover from '../ThumbnailPopover';
import ThumbnailInline from '../ThumbnailInline';
import ThumbnailOnly from '../ThumbnailOnly';
import CustomVideoCta from '../CustomVideoCta';
import PlayCtaPopover from '../PlayCtaPopover';

const WistiaComponentMap = {
  isLabelPopover: PlayLabelPopover,
  isButtonPopover: PlayButtonPopover,
  isCustomCtaPopover: CustomVideoCta,
  isThumbnailInline: ThumbnailInline,
  isThumbnailOnly: ThumbnailOnly,
  isThumbnailPopover: ThumbnailPopover,
  isCtaPopoverVideo: PlayCtaPopover,
};

const getWistiaComponent = ({
  label,
  buttonPopover,
  customCta,
  playButtonOnly,
  thumbnailOnly,
  thumbnailInline,
  inline,
  isCtaPopoverVideo,
  isMobile,
}) => {
  const mobileThumbnailPopover = isMobile && (thumbnailInline || thumbnailOnly || inline);

  const videoType = mobileThumbnailPopover
    ? 'isThumbnailPopover'
    : label
    ? 'isLabelPopover'
    : customCta
    ? 'isCustomCtaPopover'
    : buttonPopover || playButtonOnly
    ? 'isButtonPopover'
    : thumbnailOnly
    ? 'isThumbnailOnly'
    : thumbnailInline || inline
    ? 'isThumbnailInline'
    : isCtaPopoverVideo
    ? 'isCtaPopoverVideo'
    : 'isThumbnailPopover';

  return WistiaComponentMap[videoType] || null;
};

export default getWistiaComponent;
